"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PING_INTERVAL = exports.ApiRoutes = exports.QUERY_MAX_LENGTH = exports.QUERY_MIN_LENGTH = exports.Subset = exports.Dataset = void 0;
var Dataset;
(function (Dataset) {
    Dataset["AIRDROP"] = "airdrop";
    Dataset["AVATARS"] = "avatars";
    Dataset["AWARD"] = "award";
    Dataset["AUCTION"] = "auction";
    Dataset["BADGES"] = "badges";
    Dataset["COLLECTION"] = "collection";
    Dataset["MILESTONE"] = "milestone";
    Dataset["MILESTONE_RMS"] = "milestone_rms_t2";
    Dataset["MILESTONE_SMR"] = "milestone_smr";
    Dataset["MEMBER"] = "member";
    Dataset["NFT"] = "nft";
    Dataset["NFT_STAKE"] = "nft_stake";
    Dataset["NOTIFICATION"] = "notification";
    Dataset["PROJECT"] = "project";
    Dataset["PROPOSAL"] = "proposal";
    Dataset["SPACE"] = "space";
    Dataset["STAKE"] = "stake";
    Dataset["STAKE_REWARD"] = "stake_reward";
    Dataset["STAMP"] = "stamp";
    Dataset["TOKEN"] = "token";
    Dataset["TOKEN_MARKET"] = "token_market";
    Dataset["TOKEN_PURCHASE"] = "token_purchase";
    Dataset["TICKER"] = "ticker";
    Dataset["TRANSACTION"] = "transaction";
    Dataset["SWAP"] = "swap";
})(Dataset || (exports.Dataset = Dataset = {}));
var Subset;
(function (Subset) {
    Subset["OWNERS"] = "owners";
    Subset["PARTICIPANTS"] = "participants";
    Subset["MEMBERS"] = "members";
    Subset["GUARDIANS"] = "guardians";
    Subset["BLOCKED_MEMBERS"] = "blockedMembers";
    Subset["KNOCKING_MEMBERS"] = "knockingMembers";
    Subset["TRANSACTIONS"] = "transactions";
    Subset["DISTRIBUTION"] = "distribution";
    Subset["STATS"] = "stats";
    Subset["VOTES"] = "votes";
    Subset["RANKS"] = "ranks";
})(Subset || (exports.Subset = Subset = {}));
/**
 * QUERY min length
 */
exports.QUERY_MIN_LENGTH = 1;
/**
 * QUERY max length
 */
exports.QUERY_MAX_LENGTH = 100;
/**
 * Public API routes.
 */
var ApiRoutes;
(function (ApiRoutes) {
    ApiRoutes["GET_BY_ID"] = "/search/getById";
    ApiRoutes["GET_MANY_BY_ID"] = "/search/getManyById";
    ApiRoutes["GET_MANY"] = "/search/getMany";
    ApiRoutes["GET_MANY_ADVANCED"] = "/search/getManyAdvanced";
    ApiRoutes["GET_UPDATED_AFTER"] = "/search/getUpdatedAfter";
    ApiRoutes["GET_TOKEN_PRICE"] = "/search/getTokenPrice";
    ApiRoutes["GET_AVG_PRICE"] = "/search/getAvgPrice";
    ApiRoutes["GET_PRICE_CHANGE"] = "/search/getPriceChange";
    ApiRoutes["GET_ADDRESSES"] = "/search/addresses";
    ApiRoutes["GET_TOP_MILESTONES"] = "/search/getTopMilestones";
    ApiRoutes["GET_NFT_MUTABLE_METADATA"] = "/search/getNftMutableMetadata";
    ApiRoutes["GET_NFT_IDS"] = "/search/getNftIds";
    ApiRoutes["GET_NFT_MUTABLE_METADATA_HISTORY"] = "/search/getNftMutableMetadataHistory";
})(ApiRoutes || (exports.ApiRoutes = ApiRoutes = {}));
exports.PING_INTERVAL = 10000;
